<template>
  <div class="deed">
    <QueryForm @toQuery="queryBtnClick" :load="loading" />
    <div class="flex flex-between bar">
      <div>
        订单数：<strong>{{ totalItem }}</strong>
      </div>
      <div>
        总金额：<strong>￥{{ totalMoney }} </strong>元
      </div>
    </div>
    <div class="tableWrapper" v-loading="loading">
      <div v-for="(item, index) in tableData" :key="index" class="list">
        <div class="flex flex-row">
          <div class="list-left flex-1">
            <div class="list-title first">
              <div>
                <label>委托单号：</label>
                <span>{{ item.checkmallOrderMainId }}</span>
              </div>
            </div>
            <OrderBase :row="item" />
          </div>
          <div class="list-center flex flex-column">
            <div class="list-title">委托单流程</div>
            <div class="flex-1 flex flex-middle list-flow">
              <OrderFlow :row="item" />
            </div>
          </div>
          <div class="list-right">
            <div class="list-title">操作</div>
            <Operation
              :row="item"
              @viewDeed="viewDeed(item)"
              @updatePrice="updatePrice(item)"
              @refresh="refresh"
              @viewLogistics="viewLogistics(item)"
              @addRetreatLogistics="addRetreatLogistics(item)"
              @viewRetreatLogistics="viewRetreatLogistics(item)"
              @uploadReport="uploadReportClick(item)"
              @refundExamine="refundExamine(item)"
            />
          </div>
        </div>
        <div class="list-msg">用户留言：{{ item.leavingMessage }}</div>
      </div>
    </div>
    <!-- 分页-->
    <Pagination
      :total="totalItem"
      :page="page"
      @pageIndexChange="handlePageChange"
    />
    <el-drawer
      title="委托单详情"
      :visible.sync="drawer"
      size="800px"
      class="drawer"
      :wrapperClosable="false"
    >
      <DeedDetail v-if="drawer" :deedId="currentRowData.checkmallOrderMainId" />
    </el-drawer>
    <!-- 废弃此订单弹窗 -->
    <DiscardDialog v-model="discardVisible" />
    <!--修改订单价格弹窗 -->
    <UpdatePriceDialog
      v-model="updatePriceVisible"
      :data="currentRowData"
      @success="updatePriceSuccess"
    />
    <!-- 查看寄样信息弹窗-->
    <ViewLogisticsDialog
      v-model="viewLogisticsVisible"
      v-if="viewLogisticsVisible"
      :order="orderLogis"
    />
    <AddLogisticsDialog
      v-model="addLogisticsVisible"
      v-if="addLogisticsVisible"
      :deedId="currentRowData.checkmallOrderMainId"
      :order="currentRowData"
      :isRetreat="isRetreat"
      @addLogSuccess="refreshList"
    />
    <!-- 上传和查看检测报告-->
    <UploadReportDialog
      v-model="reportVisible"
      v-if="reportVisible"
      :data="currentRowData"
      @uploadReportSuccess="refreshList"
    />
    <!-- 退款审核弹窗-->
    <RefundExamineDialog
      v-model="examineVisible"
      v-if="examineVisible"
      :order="currentRowData"
      @refresh="refreshList"
    />
  </div>
</template>
<script>
import { PAY_TYPE } from "@/constant/dict";
import { deedList, deedTotalMoney } from "@/api/userCenter";
import Pagination from "@/components/Pagination/index";
import OrderFlow from "@/components/OrderFlow/Deed";
import DeedDetail from "@/components/DeedDetail";
import QueryForm from "./components/QueryForm";
import OrderBase from "./components/OrderBase";
import Operation from "./components/Operation";
import ViewLogisticsDialog from "@/components/Logistics/ViewLogistics";
import AddLogisticsDialog from "@/components/Logistics/AddLogistics";
import DiscardDialog from "./components/DiscardDialog";
import UpdatePriceDialog from "./components/UpdatePriceDialog";
import UploadReportDialog from "./components/UploadReportDialog";
import RefundExamineDialog from "./components/RefundExamineDialog";
export default {
  components: {
    Pagination,
    QueryForm,
    OrderBase,
    OrderFlow,
    Operation,
    DeedDetail,
    DiscardDialog,
    UpdatePriceDialog,
    ViewLogisticsDialog,
    AddLogisticsDialog,
    UploadReportDialog,
    RefundExamineDialog,
  },
  data() {
    return {
      discardVisible: false,
      updatePriceVisible: false,
      totalItem: 0,
      totalMoney: 0,
      drawer: false,
      payTypeMap: {},
      page: {
        pageIndex: 1,
        pageSize: 5,
      },
      tableData: [],
      loading: false,
      queryParams: {},
      viewLogisticsVisible: false,
      orderLogis: {},
      addLogisticsVisible: false,
      currentRowData: {},
      isRetreat: false, // 是否是退样
      reportVisible: false,
      examineVisible: false, // 退款审核弹窗
    };
  },
  created() {
    this.getPayTayeDict();
    this.getDeedList();
    this.getTotalMoney();
  },
  methods: {
    // 获取总金额
    async getTotalMoney() {
      const _params = this.handleParams();
      const totalMoney = await this.$axios.post(deedTotalMoney, _params);
      this.totalMoney = totalMoney;
    },
    // 获取字典数据
    async getPayTayeDict() {
      const data = await this.$store.dispatch("getDictData", PAY_TYPE);
      const payMap = {};
      data.forEach((item) => {
        payMap[item.dictValue] =
          item.dictLabel === "未选择" ? "未选择支付方式" : item.dictLabel;
      });
      this.payTypeMap = payMap;
    },
    // 处理查询参数
    handleParams() {
      const { time, ...rest } = this.queryParams;
      const _params = {
        ...this.page,
        orderListType: 1, // 0：用户列表 1：实验室列表
        ...rest,
      };
      if (time && time.length) {
        Object.assign(_params, {
          beginTime: time[0],
          endTime: time[1],
        });
      }
      return _params;
    },
    // 获取委托单列表数据
    async getDeedList() {
      this.loading = true;
      const _params = this.handleParams();
      // orderListType:获取订单列表类型 0：用户列表 1：实验室列表
      const { list, totalItem } = await this.$axios
        .post(deedList, _params)
        .finally(() => {
          this.loading = false;
        });
      this.tableData = list;
      this.totalItem = totalItem;
      await this.getTotalMoney(_params);
    },
    // 查询按钮的点击
    queryBtnClick(params) {
      this.queryParams = params;
      this.page.pageIndex = 1;
      this.getDeedList();
      this.getTotalMoney();
    },
    handlePageChange(index) {
      this.page.pageIndex = index;
      this.getDeedList();
    },
    // 按钮状态修改后，刷新表格
    refresh() {
      this.getDeedList();
    },
    // 查看委托单
    viewDeed(data) {
      this.currentRowData = data;
      this.drawer = true;
    },
    // 废弃此订单
    // discardDeed(data) {
    //   console.log(data);

    //   this.discardVisible = true;
    // },
    // 修改订单价格
    updatePrice(data) {
      this.currentRowData = data;
      this.updatePriceVisible = true;
    },
    // 修改价格成功
    updatePriceSuccess() {
      this.refreshList();
      this.getTotalMoney();
    },
    // 查看寄样物流信息
    viewLogistics(item) {
      const {
        sampleMailExpressCompany,
        sampleMailExpressCode,
        sampleMailNumber,
      } = item.checkmallOrdeListMailExpress;
      this.orderLogis = {
        orderExpressCompany: sampleMailExpressCompany,
        orderExpressCompanyCode: sampleMailExpressCode,
        orderExpressNum: sampleMailNumber,
      };
      this.viewLogisticsVisible = true;
    },
    // 添加退样物流信息
    addRetreatLogistics(data) {
      this.currentRowData = data;
      this.addLogisticsVisible = true;
      this.isRetreat = true;
    },
    // 刷新列表数据
    refreshList() {
      this.getDeedList();
    },
    // 查看退样物流信息
    viewRetreatLogistics(item) {
      const {
        recoverMailExpressCompany,
        recoverMailExpressCode,
        recoverMailNumber,
      } = item.checkmallOrdeListMailExpress;
      this.orderLogis = {
        orderExpressCompanyCode: recoverMailExpressCode,
        orderExpressCompany: recoverMailExpressCompany,
        orderExpressNum: recoverMailNumber,
      };
      this.viewLogisticsVisible = true;
    },
    // 点击上传报告按钮
    uploadReportClick(data) {
      this.currentRowData = data;
      this.reportVisible = true;
    },
    // 退款审核
    refundExamine(data) {
      this.currentRowData = data;
      this.examineVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.drawer {
  /deep/ .el-drawer__header span {
    font-weight: bold;
    font-size: 1.07rem;
  }
}
.deed {
  padding: 10px;
}
.tableWrapper {
  min-height: 400px;
  margin-bottom: 10px;
}
.list {
  border: 1px solid $border-color;
  margin-bottom: 10px;
  &-title {
    height: 35px;
    line-height: 35px;
    background: $head-bar-bg;
    padding-left: 10px;
    border-bottom: 1px solid $border-color;
    text-align: center;
    &.first {
      text-align: left;
    }
  }
  &-left {
    border-right: 1px solid $border-color;
  }
  &-center {
    width: 430px;
    border-right: 1px solid $border-color;
  }
  &-right {
    width: 150px;
  }
  &-time {
    font-weight: bold;
    margin-right: 15px;
  }
  &-msg {
    border-top: 1px solid $border-color;
    padding: 10px;
  }
  &-flow {
    > div {
      width: 100%;
    }
  }
}
.bar {
  height: 35px;
  line-height: 35px;
  background: #eaf1fe;
  border: 1px solid #d6e3fd;
  padding: 0 10px;
  strong {
    color: $price-color;
  }
}
</style>
